import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-Authors',
  templateUrl: './Authors.component.html',
  styleUrls: ['./Authors.component.scss']
})
export class AuthorsComponent implements OnInit {
title = 'Authors';
  constructor() { }

  ngOnInit() {
  }

}
